import { InstallmentsEnum } from '../enums';

const generalError = {
  title: InstallmentsEnum.MainTitleError,
  message: InstallmentsEnum.ErrroCallBack,
  btnLabel: InstallmentsEnum.CloseAndContinue,
};

export enum ErrorDecision {
  NegativeDecision = 'negative_decision',
}

export enum SmsErrors {
  InvalidPin = 'invalid_pin',
  InvalidPinRequestNew = 'invalid_pin_request_new',
}

export type ErrorConfig = {
  title: InstallmentsEnum;
  message: InstallmentsEnum;
  btnLabel: InstallmentsEnum;
};

export const errorConfig = new Map<
  string,
  ErrorConfig | ErrorDecision | SmsErrors
>([
  ['hi-pro-process-failure', generalError],
  ['hi-pro-validation-error', generalError],
  [
    'hi-pro-incorrect-street-name',
    {
      title: InstallmentsEnum.ErrorAddressStreetTitle,
      message: InstallmentsEnum.ErrorAddressStreetSubTitle,
      btnLabel: InstallmentsEnum.CloseAndCorrect,
    },
  ],
  [
    'request.street:too-long',
    {
      title: InstallmentsEnum.ErrorAddressStreetTitle,
      message: InstallmentsEnum.ErrorAddressStreetSubTitle,
      btnLabel: InstallmentsEnum.CloseAndCorrect,
    },
  ],
  [
    'request.street:too-short',
    {
      title: InstallmentsEnum.ErrorAddressStreetTitle,
      message: InstallmentsEnum.ErrorAddressStreetSubTitle,
      btnLabel: InstallmentsEnum.CloseAndCorrect,
    },
  ],
  [
    'hi-pro-incorrect-apartment-number',
    {
      title: InstallmentsEnum.ErrorAddressApartmentNumberTitle,
      message: InstallmentsEnum.CorrectData,
      btnLabel: InstallmentsEnum.CloseAndCorrect,
    },
  ],
  [
    'hi-pro-incorrect-house-number',
    {
      title: InstallmentsEnum.ErrorAddressHouseNumberTitle,
      message: InstallmentsEnum.CorrectData,
      btnLabel: InstallmentsEnum.CloseAndCorrect,
    },
  ],
  [
    'hi-pro-incorrect-zip-code',
    {
      title: InstallmentsEnum.ErrorAddressZipCodeTitle,
      message: InstallmentsEnum.CorrectData,
      btnLabel: InstallmentsEnum.CloseAndCorrect,
    },
  ],
  ['hi-pro-app-id-already-used', generalError],
  [
    'hi-pro-incorrect-pesel',
    {
      title: InstallmentsEnum.ErrorAddressMailTitle,
      message: InstallmentsEnum.CorrectData,
      btnLabel: InstallmentsEnum.CloseAndCorrect,
    },
  ],
  [
    'hi-pro-incorrect-phone-number',
    {
      title: InstallmentsEnum.ErrorAddressPhoneNumberTitle,
      message: InstallmentsEnum.ErrorAddressPhoneNumberSubTitle,
      btnLabel: InstallmentsEnum.CloseAndCorrect,
    },
  ],
  [
    'hi-pro-incorrect-email',
    {
      title: InstallmentsEnum.ErrorAddressMailTitle,
      message: InstallmentsEnum.CorrectData,
      btnLabel: InstallmentsEnum.CloseAndCorrect,
    },
  ],
  ['hi-pro-incorrect-last-name', ErrorDecision.NegativeDecision],
  ['hi-pro-loan-unavailable', ErrorDecision.NegativeDecision],
  ['hi-pro-wrong-action', generalError],
  [
    'hi-pro-phone-number-already-used',
    {
      title: InstallmentsEnum.ErrorAddressPhoneUnAcceptedTitle,
      message: InstallmentsEnum.ErrorAddressPhoneUnAcceptedSubTitle,
      btnLabel: InstallmentsEnum.CloseAndCorrect,
    },
  ],
  [
    'hi-pro-email-already-used',
    {
      title: InstallmentsEnum.ErrorAddressMailUnAcceptedTitle,
      message: InstallmentsEnum.ErrorAddressMailUnAcceptedSubTitle,
      btnLabel: InstallmentsEnum.CloseAndCorrect,
    },
  ],
  [
    'hi-pro-phone-number-and-email-already-used',
    {
      title: InstallmentsEnum.ErrorAddressMainAndPhoneTitle,
      message: InstallmentsEnum.ErrorAddressMainAndPhoneTitleSubTitle,
      btnLabel: InstallmentsEnum.CloseAndCorrect,
    },
  ],
  ['hi-pro-undefined-error', generalError],
  ['hi-pro-amount-too-low', ErrorDecision.NegativeDecision],
  ['hi-pro-amount-too-high', ErrorDecision.NegativeDecision],
  ['hi-pro-invalid-pin', SmsErrors.InvalidPin],
  ['hi-pro-invalid-pin-new-requested', SmsErrors.InvalidPinRequestNew],
]);

export const getMubiInstalmentError = (
  errorKey: string
):
  | {
      title: InstallmentsEnum;
      message: InstallmentsEnum;
      btnLabel: InstallmentsEnum;
    }
  | ErrorDecision
  | SmsErrors
  | undefined => {
  const error = errorConfig.get(errorKey);

  return error;
};
